/**
 * bri-stock-line: weergave van de voorraadregel (zie blocks/bri-stock-line.liquid). Het getal is een weergave per bezoeker, geen echte voorraad.
 * - Startgetal per product en bezoeker (localStorage): in 1 van de 5 gevallen 9, anders 10 tot 12; ondergrens 2 tot 4.
 * - Pas als het blok in beeld komt begint het aftellen: na 3 tot 5 seconden een stap van 1, daarna met tussenpozen die groter worden naarmate het getal lager is.
 * - Bij 3 of minder verdwijnt "Only N left in stock." en verschijnt "Very limited availability."
 */
(() => {
  if (customElements.get('bri-stock-line')) return;

  /** Willekeurig geheel getal van `laag` t/m `hoog`. */
  const tussen = (laag, hoog) => laag + Math.floor(Math.random() * (hoog - laag + 1));

  /** Pauze in ms voor de volgende stap, afhankelijk van het huidige getal. */
  const pauzeBij = (n) => {
    if (n > 6) return tussen(30000, 55000);
    if (n > 3) return tussen(40000, 70000);
    return tussen(60000, 90000);
  };

  class BriStockLine extends HTMLElement {
    #sleutel = '';
    #stand = null;
    #timer = 0;
    #gestart = false;

    connectedCallback() {
      this.#sleutel = `bri_stock_line_${this.dataset.product || 'onbekend'}`;
      this.#stand = this.#lees() || this.#nieuw();
      this.#bewaar();
      this.#toon();
      if (!('IntersectionObserver' in window)) return this.#begin();
      const kijker = new IntersectionObserver((regels) => {
        if (regels.some((r) => r.isIntersecting)) {
          kijker.disconnect();
          this.#begin();
        }
      });
      kijker.observe(this);
    }

    disconnectedCallback() {
      clearTimeout(this.#timer);
    }

    #nieuw() {
      return { n: tussen(1, 5) === 1 ? 9 : tussen(10, 12), min: tussen(2, 4), eerste: false };
    }

    #lees() {
      try {
        const x = JSON.parse(localStorage.getItem(this.#sleutel) || 'null');
        return x && typeof x.n === 'number' ? x : null;
      } catch (_) {
        return null;
      }
    }

    #bewaar() {
      try {
        localStorage.setItem(this.#sleutel, JSON.stringify(this.#stand));
      } catch (_) {
        /* opslag geblokkeerd: de stand geldt dan alleen voor deze pagina */
      }
    }

    #toon() {
      const laag = this.#stand.n <= 3;
      this.querySelector('[data-bri-stock-count-line]').hidden = laag;
      this.querySelector('[data-bri-stock-low]').hidden = !laag;
      this.querySelector('[data-bri-stock-count]').textContent = String(this.#stand.n);
    }

    #stap(grootte) {
      this.#stand = this.#lees() || this.#stand;
      if (this.#stand.n <= this.#stand.min) return;
      this.#stand.n = Math.max(this.#stand.n - grootte, this.#stand.min);
      this.#bewaar();
      this.#toon();
    }

    #volgende() {
      clearTimeout(this.#timer);
      if (this.#stand.n <= 3) return;
      this.#timer = setTimeout(() => {
        this.#stap(this.#stand.n > 6 ? tussen(1, 2) : 1);
        this.#volgende();
      }, pauzeBij(this.#stand.n));
    }

    #begin() {
      if (this.#gestart) return;
      this.#gestart = true;
      if (this.#stand.eerste || this.#stand.n <= this.#stand.min) return this.#volgende();
      this.#timer = setTimeout(() => {
        this.#stand = this.#lees() || this.#stand;
        if (!this.#stand.eerste) {
          this.#stap(1);
          this.#stand.eerste = true;
          this.#bewaar();
        }
        this.#volgende();
      }, tussen(3000, 5000));
    }
  }

  customElements.define('bri-stock-line', BriStockLine);
})();
